// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `QueueStatus`.
const QueueStatus = __t.enum("QueueStatus", {Searching: __t.unit(),
  Found: __t.unit(),
  Cancelled: __t.unit(),
  Expired: __t.unit(),
});

export default QueueStatus;


